import React, { useEffect, useRef, useState } from 'react';
import './AudioPlayer.scss';
import Button from '@atoms/Button/Button';
import { BsFillPlayFill } from 'react-icons/bs';
import { Box } from '@material-ui/core';
import { IoIosPause } from 'react-icons/io';

interface Props {
    src: string;
    name: string;
}

const calculateTime = (secs: number) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
};

enum PlayState {
    Play = 'PLAY',
    Pause = 'PAUSE',
}

const AudioPlayer: React.FC<Props> = ({ src, name }) => {
    const progressRef = useRef<any>(null);
    const audioRef = useRef<any>(null);
    const [duration, setDuration] = useState<number>();
    const [playState, setPlayState] = useState<PlayState>(PlayState.Pause);
    const [currentTime, setCurrentTime] = useState<number>(0);

    const onPlayClicked = () => {
        if (playState === PlayState.Pause) {
            audioRef.current.play();
            setPlayState(PlayState.Play);
        } else {
            audioRef.current.pause();
            setPlayState(PlayState.Pause);
        }
    };

    const onPregressClicked = (e: any) => {
        if (!duration) return;
        const barWidth = progressRef.current.clientWidth;
        const buffer = (window.innerWidth - barWidth) / 2;

        const progress = (e.clientX - buffer) / barWidth;
        const newCurrentTime = audioRef.current.duration * progress;
        setCurrentTime(newCurrentTime);
        audioRef.current.currentTime = newCurrentTime;

        if (playState === PlayState.Pause) {
            audioRef.current.play();
            setPlayState(PlayState.Play);
        }
    };

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.addEventListener('loadedmetadata', () => {
                setDuration(audioRef.current.duration);
            });

            audioRef.current.addEventListener('timeupdate', () => {
                setCurrentTime(audioRef.current.currentTime);
            });
        }
    }, [audioRef.current]);

    return (
        <div className="AudioPlayer">
            <Box display="flex" alignItems="center">
                <Button
                    label={
                        playState === PlayState.Pause ? (
                            <BsFillPlayFill size="24" />
                        ) : (
                            <IoIosPause size="24" />
                        )
                    }
                    size="s"
                    theme="pink-gradient"
                    onClick={onPlayClicked}
                    className="AudioPlayer--cta"
                />
                {/* sound wave animation */}
                <Box sx={{ ml: 2, width: '100%' }}>
                    <div
                        className={`boxContainer ${
                            playState === PlayState.Play ? 'playing' : 'pause'
                        }`}
                    >
                        <div className="box box1"></div>
                        <div className="box box2"></div>
                        <div className="box box3"></div>
                        <div className="box box4"></div>
                        <div className="box box3"></div>
                        <div className="box box4"></div>
                        <div className="box box5"></div>
                        <div className="box box1"></div>
                        <div className="box box2"></div>
                        <div className="box box3"></div>
                        <div className="box box4"></div>
                        <div className="box box5"></div>
                        <div className="box box1"></div>
                        <div className="box box2"></div>
                        <div className="box box1"></div>
                        <div className="box box2"></div>
                        <div className="box box3"></div>
                        <div className="box box4"></div>
                        <div className="box box5"></div>
                    </div>
                </Box>
            </Box>

            <audio ref={audioRef} preload="metadata" src={src}>
                <source src={src} type="audio/mpeg" />
            </audio>
        </div>
    );
};

export default AudioPlayer;
